import { apiClientV2 } from '@/services/rest-api/apiClient'

const baseURL = process.env.VUE_APP_API_FLEET_PLANNING_URL

export const uploadFile = async (data) => {
  const formData = new FormData()
  for (const [key, value] of Object.entries(data)) {
    formData.append(key, value)
  }

  const res = await apiClientV2.post('/fleet-task-instant/import/excel', formData, {
    method: 'POST',
    baseURL,
    headers: { 'Content-Type': 'multipart/form-data' },
  })

  return res?.data
}